import Constants from '../common/constants';

const { ReduxAction } = Constants;

const setPromoCodesGift = (dispatch, data) => {
  dispatch({
    type:    ReduxAction.PromoCodesGiftSet,
    payload: data,
  });
};

const showPromoCodeLoadingOverlay = (dispatch) => {
  dispatch({
    type: ReduxAction.PromoCodesLoadingOverlayShow,
  });
};

const hidePromoCodeLoadingOverlay = (dispatch) => {
  dispatch({
    type: ReduxAction.PromoCodesLoadingOverlayHide,
  });
};

const promoCodeAction = {
  setPromoCodesGift,
  hidePromoCodeLoadingOverlay,
  showPromoCodeLoadingOverlay,
};

export default promoCodeAction;
